<template>
  <v-row dense>
    <v-col>
      <v-card flat>
        <v-card-text class="px-3 pt-2 pb-1">
          <DataListHeading
            label="Системні налаштування"
            disabled
            :search-field="false"
            :divider="false"
          />

          <v-row class="px-3">
            <v-toolbar-title>Звіти</v-toolbar-title>
          </v-row>
          <v-row class="px-2">
            <v-tooltip
              bottom
            >
              <template v-slot:activator="{ on }">
                <h2
                  class="subtitle-1 font-weight-medium mx-1 mr-4"
                  v-on="on"
                >
                  Активувати перевірку
                </h2>
              </template>
              <span>Перевірка наявності проектів без клієнта, співробітників без грейду</span>
            </v-tooltip>
            <v-switch
              v-model="reportCheck"
              color="green"
              dense
              :loading="loading"
              @change="updateReportsCheck"
            />
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import DataListHeading from "../../components/DataListHeading.vue";
import * as settingsApi from "../../backend/settingsApi.js";

export default {
  components: {
    DataListHeading,
  },
  data: () => ({
    reportCheck: false,
    loading: false,
  }),
  created() {
    this.getReportsCheck();
  },
  methods: {
    async getReportsCheck(){
      this.loading = true;
      this.reportCheck = await settingsApi.getGlobalSettingsReportsCheck();
      this.loading = false;
    },
    async updateReportsCheck(){
      this.loading = true;
      await settingsApi.updateGlobalSettingsReportsCheck(this.reportCheck);
      this.$notifySuccess();
      this.loading = false;
    },
  },
};
</script>
